import React, { cloneElement } from "react";
import {
  useListContext,
  TopToolbar,
  CreateButton,
  ExportButton,
} from "react-admin";

const ListActions = (props) => {
  const { filters, maxResults } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <CreateButton />
      <ExportButton maxResults={maxResults} />
    </TopToolbar>
  );
};

export default ListActions;
